import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import MoneyUtils from '../../services/MoneyUtils';
import './style.css';
import ExternalImage from '../product/ExternalImage';

const UpsellBox = (props) => (
  <Row className='upsellDetails'>
    <Col xs={12} sm={12} md={12} lg={12}>
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <h3 className='upsellHeader'>{props.header}</h3>
          <h5>{props.subHeader}</h5>
        </Col>
      </Row>
      <Row className='productDetails'>
        <Col
          className='no-horizontal-padding upsellImage'
          xs={3}
          sm={3}
          md={4}
          lg={4}
        >
          <ExternalImage
            src={props.image}
            sizes='(max-width: 414px) 50vw, 25vw'
            alt={props.productName}
          />
        </Col>
        <Col xs={7} sm={7} md={8} lg={8}>
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className='sub-description'>{props.productDescription}</div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6} md={4} lg={4}>
              <div className='regPrice'>
                ${MoneyUtils.formatAsMoney(props.regPrice)}
              </div>
            </Col>
            <Col xs={12} sm={6} md={4} lg={4}>
              <div className='price'>
                ${MoneyUtils.formatAsMoney(props.price)}
              </div>
            </Col>
          </Row>
          {props.buttonAction && props.buttonText ? (
            <Button
              active={false}
              block={false}
              bsPrefix='btn'
              variant='link'
              onClick={props.buttonAction}
              className='addButton'
            >
              {props.buttonText}
            </Button>
          ) : null}
        </Col>
      </Row>
    </Col>
  </Row>
);

export default React.memo(UpsellBox);
